export default __webpack_public_path__ + "static/media/logo_white.344ef4e3.png";